/**
 * @author Nihar <nihar.baishya@314ecorp.com>
 * @description SortTableData
 */
import { useMemo } from 'react';
import _ from 'lodash';
import clsx from 'clsx';
import { Dropdown, Flex } from 'antd';
import { Check, Close, SortAmountDown } from '@icon-park/react';
import Button from 'components/widgets/button';

export interface IProps {
	menuItems: SortItemType[];
	currentItem: SortItemType;
	onChange: (item: SortItemType) => void;
}

// label for the dropdown item
const getLabel = (item: SortItemType, currentItem: SortItemType) => {
	return item?.key === currentItem?.key ? (
		<Flex gap={8}>
			{item?.label}
			<Check fill='#2759CD' size={16} />
		</Flex>
	) : (
		item?.label
	);
};

// dropdown items for the sort table data
const SortTableData: React.FC<IProps> = ({ menuItems, currentItem, onChange }) => {
	// modified menu items for the sort table data
	const ModifiedMenuItems = useMemo(() => {
		return menuItems.map((item) => ({
			...item,
			label: getLabel(item, currentItem),
			asc: _.toString(item?.asc),
			onClick: () => {
				onChange(item);
			},
		}));
	}, [menuItems, currentItem]);

	return (
		<Dropdown menu={{ items: ModifiedMenuItems, activeKey: currentItem?.key }} trigger={['click']}>
			<Button
				type='default'
				icon={<SortAmountDown className={`${currentItem ? 'text-blue-active' : ''}`} />}
				onClick={(e) => e.stopPropagation()}
				className={clsx('px-2', { 'text-blue-active border-blue-active': currentItem })}
			>
				{!!currentItem && (
					<Close
						fill='#fff'
						strokeWidth={12}
						size={6}
						className='rounded-full bg-[#FF7875] p-1.5'
						onClick={(e) => {
							e.stopPropagation();
							e.preventDefault();
							onChange(null);
						}}
					/>
				)}
			</Button>
		</Dropdown>
	);
};

export default SortTableData;
